import React, { FunctionComponent, ReactText } from 'react';

import { MultiselectDropdown, ListOption } from '@components/library/dropdown/index';
import { CustomFieldKeyValuesEntry, CustomFieldPayloadOperations } from '@components/asset/modal/tabs/edit/EditTabTypes';

interface MultiValueRestrictedProps {
  currValues: ListOption[];
  dispatchCustomFieldValue: (
    optionValue: ReactText,
    operation: CustomFieldPayloadOperations,
    customFieldValueId?: string
  ) => void;
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
  options: ListOption[];
}

export const MultiValueRestricted: FunctionComponent<MultiValueRestrictedProps> = ({
  currValues,
  dispatchCustomFieldValue,
  existingCustomFieldMap,
  options
}) => (
  <MultiselectDropdown
    onChange={(_selectedOptions, isAdded, updatedValue): void => {
      const customFieldValueId = existingCustomFieldMap?.customFieldValues.find((cfv) => (
        cfv.value === updatedValue
      ))?.key;
      dispatchCustomFieldValue(
        updatedValue,
        isAdded ? CustomFieldPayloadOperations.Create : CustomFieldPayloadOperations.Delete,
        customFieldValueId
      );
    }}
    options={options}
    placeholder={`${bfTranslate("Select value(s)")}`}
    searchable
    values={currValues}
  />
);
